import styled from 'styled-components';

import { CircleButton } from 'styles/global';
import COLORS from 'styles/colors';

const Container = styled.div`
  ${CircleButton}
  padding: 10px;
  width: 80px;
  height: 80px;
  background-color: ${COLORS.purple};
  border-color: ${COLORS.purple.opacity(0.2)};
  color: ${COLORS.pinkMillennial};
  cursor: initial;
`;

const Roundel = ({ className, children }) => (
  <Container className={className}>{children}</Container>
);

export default Roundel;
